<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3cq193/tc-custom/9781601639363.jpg?1736884274749" alt="This image is the cover for the book Tell Me What to Eat if I Have Celiac Disease, Tell Me What to Eat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tell Me What to Eat if I Have Celiac Disease, Tell Me What to Eat
      </h1>
      <p class="bookDescription body article font2">
        <b>Advice and recipes for those who need to follow a gluten-free diet: “Comprehensive and invaluable.”—Bonnie J. Kruszka, author of <i>Eating Gluten-Free with Emily</i></b><br/>  <br/> Currently, following a life-long gluten-free diet is the only means to treat celiac disease—and avoid the serious health conditions and unpleasant symptoms it can cause. <i>Tell Me What to Eat if I Have Celiac Disease</i> is an informative, non-technical book written to guide anyone with celiac disease to a better understanding of a gluten-free diet, including tips from those who have celiac disease themselves. This practical reference includes:<br/>   a simple overview of the diseasean easy-to-follow and updated food guideinformation on children and celiac disease, food labeling laws, and morerecipes and advice from the celiac community an abundance of valuable resources
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kimberly A. Tessmer
      </h2>
      
      <p class="authorDescription body article">Kimberly A. Tessmer, RD, LD, is a consulting dietitian in Brunswick, Ohio. She is the author of The Everything Nutrition Book and The Everything Pregnancy Nutrition Book as well as a contributing author of Conquering Childhood Obesity for Dummies. In addition to maintaining her own Website www.Nutrifocus.net, Tessmer serves as a community expert on www.Pregnancy.org, acts as the consulting dietitian for a national weight-loss chain, and is the RD on the board of directors for Lifestyles Technologies, a weight management software company. Her consulting company, Nutrition Focus, specializes in numerous services from weight management to menu planning.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Page Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e50d602